let apiUrl;

if (window.location.hostname == 'localhost') {
    apiUrl = 'http://127.0.0.1:8000/refugio/api-refugio';
} else if (window.location.hostname == '129.148.44.148'){
    apiUrl = 'http://129.148.44.148/refugio/api-refugio';
} else if (window.location.hostname.includes('refugionaposta.com.ar')) {
    apiUrl = 'https://refugionaposta.com.ar/refugio/api-refugio';
}


console.log('apiUrl: ', apiUrl);

export const config = {
    apiUrl
};
